/**
 * @ngdoc service
 * @name tracking
 *
 * @description Tracking service.
 */
module.factory('tracking', ['cart', function($cart) {
    return {
        /**
         * Create object given to ga depending on list of params (retrieved from routing data)
         */
        retrieveData: function (params) {
            if (!params || params.length === 0) {
                return {};
            }
            const data = {};
            params.forEach(function (p) {
                if (p === 'amount') {
                    Object.assign(data, { montant: $cart.field_total_amount });
                }
            });
            return data;
        }
    }
}]);